import { createAction, props } from '@ngrx/store';
import { SingleGraphError } from 'src/app/common-components/errors/models/error-message';
import { LocationDetailSaveEvent } from '../models/location-detail-form-submit-event';
import { GetLocationDetail_location } from '../queries/generated/GetLocationDetail';
import { SaveLocation } from '../queries/generated/SaveLocation';

export const locationDetailLoad = createAction('[Location Detail] Load');

export const locationDetailCancel = createAction('[Location Detail] Cancel');

export const locationDetailAccessDenied = createAction('[Location Detail] Access Denied');

export const loadLocationDetailSuccess = createAction(
   '[API] Load Location Success',
   props<{ data: GetLocationDetail_location }>()
);

export const loadLocationDetailFailure = createAction('[API] Load Location Failure', props<SingleGraphError>());

export const saveLocationDetail = createAction('[Location Detail] Save', props<LocationDetailSaveEvent>());

export const saveLocationDetailSuccess = createAction(
   '[Location Detail] Save Success',
   props<{ data: SaveLocation }>()
);

export const saveLocationDetailFailure = createAction('[Location Detail] Save Failed', props<SingleGraphError>());

export const deleteLocation = createAction('[Location Detail] Delete Location', props<{ locationId: number }>());

export const deleteLocationSuccess = createAction(
   '[Location Detail] Delete Location Success',
   props<{ locationId: number }>()
);

export const deleteLocationFailure = createAction(
   '[Location Detail] Delete Location Failure',
   props<SingleGraphError>()
);

export const deleteFileFailure = createAction('[Location Detail] Delete File Failure', props<SingleGraphError>());
